import { Component, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { PromptModalData, ShowPromptModalActions } from './show.prompt.modal.provider';
import { MatDialogRef } from '@angular/material';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';

@Component({
  templateUrl: './show.prompt.modal.component.html',
  styleUrls: ['./show.prompt.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShowPromptModalComponent extends BaseComponent {

  public title: string;
  public message: string | null;
  public messages: string[] = [];
  public isShowCheckbox: boolean;

  public doNotShowPromptModal: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<ShowPromptModalComponent>,
    private actions: ShowPromptModalActions,
    data: PromptModalData) {
    super();

    this.title = data.title;
    this.message = data.message;
    this.messages = data.messages;
    this.isShowCheckbox = data.isShowCheckbox;
  }

  public close(): void {
    console.log(this.doNotShowPromptModal);

    if (this.isShowCheckbox) {
      if (this.doNotShowPromptModal) {
        localStorage.setItem(localStorageKeys.doNotShowRemoveSuccessfullyModal, this.doNotShowPromptModal ? "true" : "false");
      }
    }

    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/show.prompt.modal/show.prompt.modal.component.ts